// 2_components/dklab_favorites.js
// When dkLab favorite products load, moves the header favorites icon into the
// top navigation tools (desktop) or the mobile menu (before contacts clone);
// on product pages moves the favorite button into the image.

export function init() {
	if (!window.NAT?.media) {
		console.warn("[NAT] dklab_favorites.js: window.NAT.media missing — check load order");
		return;
	}

	document.addEventListener("dkLabFavouriteProductsLoaded", function () {
		placeHeaderIcon();
		observeHeaderIconTarget();

		if (document.body.classList.contains("type-product")) {
			const favoriteDiv = document.querySelector("#dkLabFavouriteDiv");
			const pImage = document.querySelector(".p-image");
			if (favoriteDiv && pImage) {
				pImage.appendChild(favoriteDiv);
			}
		}
	});

	document.addEventListener("debouncedResize", placeHeaderIcon);
}

function placeHeaderIcon() {
	const icon = document.querySelector("#dkLabFavHeaderWrapper");
	if (!icon) {
		return;
	}

	if (window.NAT.media.isMobile) {
		const wrapper = getMenuLinksWrapper();
		if (wrapper && icon.parentElement !== wrapper) {
			wrapper.appendChild(icon);
		}
		return;
	}

	const topNavTools = document.querySelector(".top-navigation-tools");
	if (topNavTools && icon.parentElement !== topNavTools) {
		topNavTools.prepend(icon);
	}
}

function observeHeaderIconTarget() {
	if (document.querySelector(".top-navigation-contacts-clone")) {
		placeHeaderIcon();
		return;
	}

	const observer = new MutationObserver(function () {
		if (document.querySelector(".top-navigation-contacts-clone")) {
			placeHeaderIcon();
			observer.disconnect();
		}
	});
	observer.observe(document.body, { childList: true, subtree: true });
}

function getMenuLinksWrapper() {
	const contactsClone = document.querySelector(".top-navigation-contacts-clone");
	if (!contactsClone || !contactsClone.parentNode) {
		return null;
	}

	let wrapper = document.querySelector(".dklab-header-menu-links");
	if (!wrapper) {
		wrapper = document.createElement("div");
		wrapper.className = "dklab-header-menu-links";
	}
	if (wrapper.nextElementSibling !== contactsClone) {
		contactsClone.parentNode.insertBefore(wrapper, contactsClone);
	}
	return wrapper;
}
